import React from 'react';
import PropTypes from 'prop-types';
import Heading from '../../../../shared/library/typography/heading';
import glamorous from 'glamorous';
import {PHONE_LANDSCAPE, PHONE} from '../../../../shared/style/breakpoints';

const StyledHeading = glamorous(Heading)({
  fontSize: 34,
  marginTop: 15,
  marginBottom: 15,
  [PHONE_LANDSCAPE]: {
    fontSize: 20
  },
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  lineHeight: 1.2,
  '>span.vs': {
    fontSize: 17,
    color: '#b2b2b2',
    fontWeight: 'normal',
    marginRight: 6,
    marginLeft: 6,
    [PHONE_LANDSCAPE]: {
      fontSize: 14,
      marginRight: 9,
      marginLeft: 9
    }
  }
});

const PackageWrapper = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 10,
  ' a': {
    display: 'flex'
  },
  [PHONE]: {
    justifyContent: 'center',
    marginLeft: 0
  }
});

const Package = glamorous.img({
  width: 76,
  marginLeft: 7,
  objectFit: 'contain'
});

const wrapVs = tools => {
  let title = [];
  for (let i = 0; i < tools.length; i++) {
    if (tools[i].name) {
      title.push(
        <span data-testid="stackupTitle" key={tools[i].slug}>
          {tools[i].name}
        </span>
      );
      if (i < tools.length - 1) {
        title.push(
          <span key={i} className="vs">
            &nbsp;vs&nbsp;
          </span>
        );
      }
    }
  }
  return title;
};

const StackupHeading = ({tools, toolsLoaded, tool}) => {
  if (!tools) return null;
  return (
    <StyledHeading>
      {wrapVs(tools)}

      {toolsLoaded &&
      tool.packageManager &&
      tools
        .map(i => i.packageManager && i.packageManager.name)
        .every(item => item === tool.packageManager.name) ? (
        <PackageWrapper>
          <a
            href={tool.packageManager.path}
            target="_blank"
            rel="noopener noreferrer"
            style={{marginTop: 5}}
          >
            <Package
              src={tool.packageManager.miniImageUrl}
              alt={`${tool.packageManager.slug} package`}
            />
          </a>
        </PackageWrapper>
      ) : (
        ''
      )}
    </StyledHeading>
  );
};

StackupHeading.propTypes = {
  tools: PropTypes.array,
  toolsLoaded: PropTypes.bool,
  tool: PropTypes.object
};

export default StackupHeading;
